<div id="featurePanel" class="featurePanel"
  [class.expanded]="(mapState.surroundingFeatureList && mapState.surroundingFeatureList.length > 0) || (mapState.selectedFeature && mapState.selectedFeature.length > 0)"
  [class.full]="mapState.expandFeaturePanel">
  <div id="rightPanelControls" class="float-right rightPanelControls d-flex justify-content-end">

    <button (click)="closeRightPanel()" class="btn-close my-1 text-right" title="Close">
      <h2 class="carouselTitle">Feature Information</h2>
      <i class="far fa-chevron-right"></i>
    </button>
  </div>
  <div class="feature-scroll">
    @if (showMultiSelect(mapState)) {
      <button type="button" (click)="carouselBack()" class="btn btn-link p-0">
        <label class="carousel__control carousel__control--backward float-left" for="sFeaturesList">
          <i class="far fa-chevron-left"></i>
          <h3 class="carouselTitle multi">Multiple Results</h3>
        </label>
      </button>
    }
    @if (!showMultiSelect(mapState) && mapState.selectedFeature == null) {
      <label
        class="carousel__control carousel__control--backward float-left">
        <h3 class="carouselTitle multi">Multiple Results</h3>
      </label>
    }
    <div class="carousel-container" [class.multi]="!showMultiSelect(mapState) && mapState.selectedFeature == null">
      <div class="carousel my-carousel carousel--translate">
        <input class="carousel__activator" type="radio" name="carousel" id="sFeaturesList" checked="checked">
        <input class="carousel__activator" type="radio" name="carousel" id="sFeaturesDetails">
        <div class="carousel__track">
          <ul>

            @if (mapState.surroundingFeatureList) {
              <li class="carousel__slide resultsList"
                [class.hidden]="mapState.selectedFeature != null && mapState.selectedFeature.length > 0">
                @for (feature of mapState.surroundingFeatureList; track feature) {
                  <label class="carousel__control carousel__control--forward px-2"
                    (mouseenter)="mouseEnter(feature.objectId, feature.featureId, feature.name)" (mouseleave)="mouseLeave()"
                    for="sFeaturesDetails"
                    (click)="setFeatureDetails(feature.objectId, feature.url, feature.writeUrl, feature.allowInsp, feature.featureId, feature.assetId)">
                    <div class="idFeature d-flex justify-content-between">
                      <div class="feature-text">
                        <span class="w-100">{{feature.name}}</span>
                        @if (feature.keyAttribute.length > 0) {
                          <span class="keyAttr">{{feature.keyAttribute |
                          linebreakAtUnderscores }}</span>
                        }
                      </div>
                      <div class="icon">
                        <i class="far fa-chevron-right mt-1 float-right"></i>
                      </div>
                    </div>
                  </label>
                }
              </li>
            }

            <li class="carousel__slide" [class.feature]="mapState.surroundingFeatureList == null"
              [class.multi]="showMultiSelect(mapState)">
              @if (mapState.selectedFeature && mapState.selectedFeature.length > 0) {
                <div>
                  <ul class="nav nav-tabs" id="featureTabs" role="tablist">
                    <li class="nav-item list-margin">
                      <a class="nav-link active" id="details-tab" data-bs-toggle="tab" href="#details" role="tab"
                      aria-controls="details" aria-selected="true" title="Details">Details</a>
                    </li>
                    @if (countRecords(relatedRecords) > 0) {
                      <li class="nav-item">
                        <a class="nav-link" id="relatedRecords-tab" data-bs-toggle="tab" href="#relatedRecords" role="tab"
                          aria-controls="relatedRecords" aria-selected="true">
                          @if (!isEnerGovLayer()) {
                            <span>Reports</span>
                          }
                          @if (isEnerGovLayer()) {
                            <span>Cases</span>
                          }
                          <span> ({{ countRecords(relatedRecords) }})</span></a>
                        </li>
                      }
                      @if (cctvInspections && cctvInspections.length > 0) {
                        <li class="nav-item">
                          <a class="nav-link" id="cctvInspections-tab" data-bs-toggle="tab" href="#cctvInspections" role="tab"
                            aria-controls="cctvInspections" aria-selected="true">CCTV
                            <span>({{cctvInspections.length}})</span></a>
                          </li>
                        }
                      </ul>
                      <div class="tab-content">
                        <div class="tab-pane fade show active pt-2" id="details" role="tabpanel"
                          aria-labelledby="details-tab">
                          @if (validRapFeatureLayer) {
                            <button class="ml-2 btn btn-outline-primary"
                              (click)="addAssetToRap()">Add Asset to
                              RAP
                            </button>
                          }
                          @if (isSchedule()) {
                            <button class="ml-2 mt-2 btn btn-outline-primary"
                            (click)="openScheduleModal(overrideModal)">Override Schedule</button>
                          }
                          <div class="featureDetails" #featureDetails>
                            @if (selectedFeatureAttachments && selectedFeatureAttachments.images.length > 0) {
                              <div
                                class="px-2">
                                @if (selectedFeatureAttachments.images.length > 0) {
                                  <div
                                    class="gallery-wrapper">
                                    <ngx-gallery [options]="galleryOptions" [images]="selectedFeatureAttachments.images"
                                      class="feature-gallery" [class.singleImage]="selectedFeatureAttachments.images.length == 1">
                                    </ngx-gallery>
                                  </div>
                                } @else {
                                  <ng-template [ngTemplateOutlet]="noAttachment"></ng-template>
                                }
                                @if (selectedFeatureAttachments.others.length > 0) {
                                  <div class="non-image">
                                    <h4>Non-image attachment(s):</h4>
                                    <ul class="attachments">
                                      @for (attachment of selectedFeatureAttachments.others; track attachment) {
                                        <li>
                                          <a href="{{attachment.url}}" target="_blank">{{attachment.name}}</a> (size:
                                          {{attachment.size/1000}}
                                          MB)
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                }
                              </div>
                            }
                            <dnv-key-value-section [kvSections]="kvSections" [excludesList]="mapState.excludeFeatureInfo"
                            (onExpandPanel)="expandPanel($event)" [spinnerStatus]="externalFeature"></dnv-key-value-section>
                            <dnv-alerts [hidden]="alertHidden" level="alert-danger"
                            message="There is no FlowWorks data available." (onRetry)="retry()"></dnv-alerts>
                          </div>
                        </div>
                        <!-- reports / cases -->
                        <div class="tab-pane fade pt-2" id="relatedRecords" role="tabpanel"
                          aria-labelledby="relatedRecords-tab">
                          @if (relatedRecords && relatedRecords.length > 0; as recsLength) {
                            <div>
                              @if (recsLength > 0) {
                                <div class="panels">
                                  @for (record of relatedRecords; track record) {
                                    <div class="panel">
                                      <!-- <ngx-gallery [options]="testOptions" [images]="testImages" #testgallery></ngx-gallery> -->
                                      @if (record.records.length > 0) {
                                        <div>
                                          <h3 class="tblName title">{{ record.tblName}}</h3>
                                          <button class="btn btn-primary btn-download float-right" (click)="exportInspections(record)"
                                            title="Export"><i class="fal fa-download"></i></button>
                                            @for (record of record.records; track record) {
                                              <div>
                                                <button class="btn btn-link px-2 collapsed text-start" type="button" data-bs-toggle="collapse"
                                                  attr.data-bs-target="#rec{{record.objectId}}" aria-expanded="false"
                                                  attr.aria-controls="#rec{{record.objectId}}">
                                                  @for (kv of record.attrs; track kv) {
                                                    <div>
                                                      @if ((kv[0].toLowerCase().indexOf('created') > -1 || kv[0].toLowerCase().indexOf('inspected') > -1 ) && kv[0].toLowerCase().indexOf('date') >-1 ) {
                                                        <div
                                                          class="float-left">
                                                          <h4>{{ kv[1]}}</h4>
                                                        </div>
                                                      }
                                                      @if (isEnerGovLayer() && kv[0].toLowerCase().indexOf('number') > -1) {
                                                        <div
                                                          class="float-left">
                                                          <h4> {{ kv[1]}} </h4>
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                  <i class="fas fa-chevron-down fa-xs float-right"></i>
                                                  <i class="fas fa-chevron-up fa-xs float-right"></i>
                                                </button>
                                                <div id="rec{{record.objectId}}" class="collapse">
                                                  <!-- <div class="m-0 mb-3 pt-2" *ngIf="featureInspections[0].inspType != 'SANMN'">
                                                  <h4>
                                                    Attachments:<app-add-attachments header='Add Attachments To Inspection'
                                                    fileFieldID="insp-attachment"
                                                    (uploadAttachmentsPayload)="addAttachmentsToInspection(inspection, $event)">
                                                  </app-add-attachments>
                                                </h4>
                                              </div> -->
                                              @if (record.attachment && record.attachment.length > 0) {
                                                <div class="gallery-wrapper">
                                                  <ngx-gallery [options]="record.galleryOptions" [images]="record.attachment"
                                                    #featureGallery class="feature-gallery"
                                                    [class.singleImage]="record.attachment.length == 1">
                                                  </ngx-gallery>
                                                </div>
                                              }
                                              <dnv-key-value-list title="Details" [kvpairs]="record.attrs"
                                                [excludesList]="['OBJECTID', 'Plan ID', 'License ID', 'Code Case ID', 'Permit ID', 'Plan Number', 'License Number', 'Code Case Number', 'Permit Number']">
                                              </dnv-key-value-list>
                                              @if (isEnerGovLayer()) {
                                                <div class="mb-2 key-pair">
                                                  <span class="label">Link</span>
                                                  <a href="{{getEnerGovLink(record.attrs)}}" target="_blank" class="link"
                                                  rel="nofollow noopener">{{getEnerGovNumber(record.attrs)}}</a>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            } @else {
                              <div class="no-records">There are no related records</div>
                            }
                          </div>
                        }
                      </div>
                      <div class="tab-pane fade show" id="cctvInspections" role="tabpanel"
                        aria-labelledby="cctvInspections-tab">
                        @if (cctvInspections && cctvInspections.length > 0) {
                          <div class="inspections">
                            @if (cctvInspections.length > 0) {
                              <div class="panels">
                                <div class="panel">
                                  @if (selectedCCTVInspection === null) {
                                    <div>
                                      <h3 class="title">Inspections</h3>
                                      <div class="addresses">
                                        @for (insp of cctvInspections; track insp) {
                                          <div class="address d-flex justify-content-between">
                                            <div class="video text-start">
                                              @if (insp.video) {
                                                <div>
                                                  @if (insp.video.length > 0) {
                                                    <span>
                                                      <a target="_blank" href="{{insp.video}}"><i class="fas fa-video"></i></a>
                                                    </span>
                                                  }
                                                </div>
                                              }
                                            </div>
                                            <button class="w-100 btn btn-link d-flex justify-content-between"
                                              (click)="selectInspection(insp)">
                                              <div class="row mx-0 px-2">
                                                <div class="text-start">
                                                  @if (getInspectJobVals(insp.attrs); as inspObj) {
                                                    {{inspObj.jobDate | date: 'yyyy-MM-dd'}}<br />
                                                    {{inspObj.assetId}}
                                                  }
                                                </div>
                                              </div>
                                              <div class="cctv-chevron">
                                                <i class="far fa-chevron-right"></i>
                                              </div>
                                            </button>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                  @if (selectedCCTVInspection) {
                                    <div>
                                      <dnv-cctv-inspections [cctvInspections]="cctvInspections"
                                        [selectedCctvInspection]="selectedCCTVInspection" (selectCctv)="selectInspection($event)"
                                        [inspHeight]="inspectionHeight" [cctvNotes]="cctvNotes"
                                        [excludeFeaturesList]="excludeFeaturesList">
                                      </dnv-cctv-inspections>
                                      <br />
                                    </div>
                                  }
                                </div>
                              </div>
                            } @else {
                              <div class="no-records">There are no CCTV Inspections</div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #overrideModal let-modal>

    <div>
      <div class="modal-header mb-3 align-items-center">
        <h4 class="mb-0 ">Override Schedule</h4>
        <button type="button" class="btn btn-close" aria-label="Close" (click)="modal.close()"><i
        class="fa-solid fa-xmark"></i></button>
      </div>

      <form [formGroup]="scheduleForm" class="schedule d-flex flex-row justify-content-center">
        <table class="override-form">
          <tr>
            <td><label for="assetID">Asset ID</label></td>
            <td><input type="text" formControlName="assetID" style="width:60%"></td>
          </tr>
          <tr>
            <td><label for="replacementYear">Replacement Year<span class="text-danger">*</span></label></td>
            <td>
              <ng-select class="mt-1 mb-1 dd-replacement-year" style="width: 80%;" formControlName="replacementYear"
                required [searchable]="false" [appendTo]="'body'" (change)="toggleExclusionLayerCheckbox($event)">
                @for (opt of scheduleYears; track opt) {
                  <ng-option [value]="opt">
                    {{ opt }}
                  </ng-option>
                }
              </ng-select>
            </td>
          </tr>
          @if (showExclusionLayerCheckbox) {
            <tr>
              <td><label for="addToExclusionLayer">Add to Exclusion Layer?</label></td>
              <td><input type="checkbox" formControlName="addToExclusionLayer"></td>
            </tr>
          }
          <tr>
            <td><label for="comments">Override/Exclusion Reason<span class="text-danger">*</span> </label></td>
            <td>
              <textarea class="mt-1" formControlName="comments" [ngStyle]="{'width': '100%'}"></textarea>
              @if (scheduleForm.get('comments').hasError('required') && scheduleForm.get('comments').touched) {
                <div class="text-danger mt-2 small"
                  > This
                field is required </div>
              }
            </td>
          </tr>
          <tr>
            <td>
              <div class="mt-2 small"><span class="text-danger">*</span><strong> Indicates a required field</strong></div>
            </td>
          </tr>
        </table>
      </form>
      <div class="modal-footer schedule mt-3">
        <button type="button" class="btn btn-primary" (click)="updateSchedule()"
        [attr.disabled]="scheduleForm.invalid === true ? true : null">Update</button>
        <button type="button" class="btn btn-outline-primary" (click)="dismiss()">Cancel</button>
      </div>
    </div>
  </ng-template>